import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { useNavigate, Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { ArrowLeft } from "lucide-react";

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);
    const result = await login(email, password);
    if (result.success) {
      navigate("/portal");
    } else {
      setError(result.error);
    }
    setIsLoading(false);
  };

  return (
    <div className="min-h-screen bg-zinc-50 flex items-center justify-center px-4" data-testid="login-page">
      <div className="w-full max-w-md">
        <Link to="/" className="inline-flex items-center gap-2 font-['Satoshi'] text-zinc-500 hover:text-black mb-8 transition-colors" data-testid="back-to-home">
          <ArrowLeft size={18} /> Back to Home
        </Link>

        <div className="bg-white p-8 md:p-12 border border-zinc-200" data-testid="login-form-container">
          <div className="mb-8">
            <h1 className="font-['Clash_Display'] font-bold text-2xl mb-2">LIGHT CITY <span className="text-zinc-400">PORTAL</span></h1>
            <p className="font-['Satoshi'] text-zinc-600">Sign in to your member account</p>
          </div>

          {error && (
            <div className="bg-red-50 border border-red-200 text-red-700 p-3 mb-6 font-['Satoshi'] text-sm" data-testid="login-error">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-5" data-testid="login-form">
            <div>
              <label className="font-['Satoshi'] font-medium text-sm mb-2 block">Email Address</label>
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="input-sharp h-12"
                placeholder="you@example.com"
                data-testid="login-email"
              />
            </div>
            <div>
              <label className="font-['Satoshi'] font-medium text-sm mb-2 block">Password</label>
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="input-sharp h-12"
                placeholder="Enter your password"
                data-testid="login-password"
              />
            </div>
            <Button
              type="submit"
              disabled={isLoading}
              className="btn-sharp bg-black text-white hover:bg-white hover:text-black hover:shadow-[inset_0_0_0_2px_black] w-full py-6 text-sm"
              data-testid="login-submit"
            >
              {isLoading ? "Signing in..." : "Sign In"}
            </Button>
          </form>

          <p className="font-['Satoshi'] text-center text-zinc-500 text-sm mt-6">
            Don't have an account?{" "}
            <Link to="/register" className="text-black font-semibold hover:underline" data-testid="register-link">
              Create one
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
